(() => {
  const selector = '.button[data-ft-fluid]';
  const states = new WeakMap();
  const moving = new Set();
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  let frame = 0, last = 0, hovered = null, pressed = null;
  const unavailable = button => button.matches(':disabled, [aria-disabled="true"], [aria-busy="true"]');
  const init = button => {
    if (!button || !button.querySelector('.ft-fluid-label')) return null;
    if (!states.has(button)) {
      states.set(button, {button, hover:false, press:false, reveal:{x:0,v:0,target:0}, depth:{x:0,v:0,target:0}});
      button.classList.add('ft-fluid-ready');
    }
    return states.get(button);
  };
  const find = target => target instanceof Element ? init(target.closest(selector)) : null;
  // Same critically damped response as the approved right-hand comparison.
  const advance = (state,dt,response) => {
    const omega=2*Math.PI/response, offset=state.x-state.target, c=state.v+omega*offset, decay=Math.exp(-omega*dt);
    state.x=state.target+(offset+c*dt)*decay;
    state.v=(state.v-omega*c*dt)*decay;
    if(Math.abs(state.x-state.target)<.0005 && Math.abs(state.v)<.005) {state.x=state.target;state.v=0;}
  };
  const paint = s => {
    const p=Math.max(0,Math.min(1,s.reveal.x));
    s.button.style.setProperty('--ft-reveal',`${p*100}%`);
    s.button.style.setProperty('--ft-fill-x',`${(p-1)*100}%`);
    s.button.style.setProperty('--ft-press-y',`${s.depth.x*.8}px`);
  };
  const reset = s => {
    s.hover=false;s.press=false;
    for(const part of [s.reveal,s.depth]) {part.x=0;part.v=0;part.target=0;}
    s.button.removeAttribute('data-ft-pressed');
    paint(s);moving.delete(s);
  };
  const tick = time => {
    frame=0;
    const dt=last?Math.min((time-last)/1000,.05):1/60;last=time;
    for(const s of moving) {
      if(!s.button.isConnected || unavailable(s.button)) {reset(s);continue;}
      advance(s.reveal,dt,.34);advance(s.depth,dt,.22);paint(s);
      if(!s.reveal.v && !s.depth.v && s.reveal.x===s.reveal.target && s.depth.x===s.depth.target) moving.delete(s);
    }
    if(moving.size) frame=requestAnimationFrame(tick);else last=0;
  };
  const update = s => {
    if(!s) return;
    if(unavailable(s.button)) {reset(s);return;}
    s.button.toggleAttribute('data-ft-pressed',s.press);
    s.reveal.target=reduced.matches?0:(s.hover?1:0);
    s.depth.target=reduced.matches?0:(s.press?1:0);
    if(reduced.matches) {s.reveal.x=0;s.reveal.v=0;s.depth.x=0;s.depth.v=0;paint(s);moving.delete(s);}
    else {moving.add(s);if(!frame) frame=requestAnimationFrame(tick);}
  };
  const release = () => {if(pressed){pressed.press=false;update(pressed);pressed=null;}};
  const resetAll = () => {
    for(const s of new Set([...moving,hovered,pressed])) if(s) reset(s);
    hovered=null;pressed=null;cancelAnimationFrame(frame);frame=0;last=0;
  };
  document.querySelectorAll(selector).forEach(init);
  // Delegation also handles buttons inserted by variant changes and cart sections.
  document.addEventListener('pointerover',e=>{
    const s=find(e.target);
    if(!s || s.button.contains(e.relatedTarget) || unavailable(s.button)) return;
    if(e.pointerType==='mouse'||e.pointerType==='pen') {hovered=s;s.hover=true;update(s);}
  });
  document.addEventListener('pointerout',e=>{
    const s=find(e.target);
    if(!s || s.button.contains(e.relatedTarget)) return;
    s.hover=false;s.press=false;update(s);if(hovered===s)hovered=null;if(pressed===s)pressed=null;
  });
  document.addEventListener('pointerdown',e=>{
    if(e.button!==0 || !e.isPrimary) return;
    const s=find(e.target);if(!s || unavailable(s.button))return;
    release();pressed=s;s.press=true;update(s);
  });
  window.addEventListener('pointerup',release);
  window.addEventListener('pointercancel',release);
  document.addEventListener('focusin',e=>find(e.target));
  document.addEventListener('focusout',e=>{const s=find(e.target);if(s){s.press=false;update(s);if(pressed===s)pressed=null;}});
  document.addEventListener('keydown',e=>{
    const s=find(e.target);
    const activation=e.key==='Enter'||(e.key===' '&&s?.button.tagName==='BUTTON');
    if(s && activation && !e.repeat && !unavailable(s.button)){pressed=s;s.press=true;update(s);}
  });
  document.addEventListener('keyup',e=>{if(e.key===' '||e.key==='Enter')release();});
  window.addEventListener('blur',resetAll);
  window.addEventListener('pagehide',resetAll);
  window.addEventListener('pageshow',resetAll);
  document.addEventListener('visibilitychange',()=>{if(document.hidden)resetAll();});
  reduced.addEventListener('change',resetAll);
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll(selector).forEach(init));
})();
